'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NavigationButton;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function NavigationButton(props) {
  var onClick = props.onClick,
      icon = props.icon,
      disabled = props.disabled,
      dataId = props.dataId,
      ariaLabel = props.ariaLabel;

  var getClassName = function getClassName() {
    return (0, _classnames2.default)('rainbow-pagination_navigation-button-content', {
      'rainbow-pagination_navigation-button-content--disabled': disabled
    });
  };

  var handleOnClick = function handleOnClick(event) {
    if (!disabled) {
      onClick(event);
    }
  };

  var getTabIndex = function getTabIndex() {
    if (disabled) {
      return -1;
    }

    return 0;
  };

  return _react2.default.createElement('li', {
    className: 'rainbow-pagination_navigation-button'
  }, _react2.default.createElement('a', {
    className: getClassName(),
    'data-id': dataId,
    onClick: handleOnClick,
    href: 'javascript:void(0);',
    'aria-disabled': !!disabled,
    tabIndex: getTabIndex(),
    'aria-label': ariaLabel
  }, icon));
}
/* eslint-disable no-script-url */


NavigationButton.propTypes = {
  onClick: _propTypes2.default.func.isRequired,
  icon: _propTypes2.default.node.isRequired,
  disabled: _propTypes2.default.bool,
  dataId: _propTypes2.default.string,
  ariaLabel: _propTypes2.default.string
};
NavigationButton.defaultProps = {
  disabled: false,
  dataId: undefined,
  ariaLabel: undefined
};